export default __webpack_public_path__ + "static/media/plug-nbr.3bcd9366.png";